import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import FilterIcon from '@mui/icons-material/TuneOutlined';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import DatePickerModal from '@/components/Modals/DatePickerModal/DatePickerModal';
import Modal from '@/components/Modals/Modal';

import useDateFilters from './useDateFilters';

const setStyle = (state: string, name: string) => {
  return {
    bgcolor: state === name ? 'primary.main' : 'inherit',
    color: state === name ? 'white' : 'inherit',
  };
};

const DateFilters = () => {
  const hook = useDateFilters();

  return (
    <Paper
      elevation={3}
      sx={{
        mt: '2rem',
        padding: '1rem',
        display: 'flex',
        flexDirection: { xxs: 'column', sm: 'row' },
        justifyContent: 'space-around',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '0.5rem',
      }}
    >
      <Box display="flex" gap="0.5rem" alignItems="center">
        <FilterIcon color="primary" />
        <Typography variant="h6">Filtros</Typography>
      </Box>

      <Button
        variant="outlined"
        sx={setStyle(hook.dateType, 'today')}
        onClick={hook.handleChangeToday}
      >
        Hoy
      </Button>
      <Button
        variant="outlined"
        sx={setStyle(hook.dateType, 'last48hours')}
        onClick={hook.handleChangeLast48h}
      >
        Últimas 48h
      </Button>
      <Button
        variant="outlined"
        sx={setStyle(hook.dateType, 'last7days')}
        onClick={hook.handleChangeLast7Days}
      >
        Últimos 7 días
      </Button>
      <Button
        variant="outlined"
        sx={setStyle(hook.dateType, 'last30days')}
        onClick={hook.handleChangeLast30Days}
      >
        Últimos 30 días
      </Button>
      <IconButton onClick={hook.openCustomModal} sx={setStyle(hook.dateType, 'custom')}>
        <DateRangeOutlinedIcon color={hook.dateType === 'custom' ? 'inherit' : 'primary'} />
      </IconButton>
      <Modal
        isOpen={hook.openCustom}
        onClose={hook.onCloseCustomModal}
        title="Fechas de Dashboard"
        scroll="body"
        maxWidth="sm"
      >
        <DatePickerModal
          handleChangeDate={hook.customDateChange}
          title="Selecciona el período"
          onClose={hook.onCloseCustomModal}
        />
      </Modal>
    </Paper>
  );
};

export default DateFilters;
